export default __webpack_public_path__ + "static/media/rockefeller_plaza.e3945a8f.jpg";